<template>
    <div v-if="execute">
        <div id="shopsListWrap" :style="cssProps">
            <section class="list-of-stores-box mt-5 mb-5">
                <div class="container">
                    <div class="row category-checkbox-container">
                        <div class="col-lg-3 col-12">
                            <SearchSidebar />
                        </div>
                        <div class="col-12 col-lg-9 ">
                            <SearchContent :category-id-from-url="categoryIdFromUrl" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import SearchSidebar from '@/components/SearchSidebar'
    import SearchContent from '@/components/SearchContent'
    import * as AppConfig from '@/config/AppConfig'

    export default {
        name: 'App',
        components: {
            SearchSidebar,
            SearchContent
        },
        data () {
            return {
              execute: false,
              categoryIdFromUrl: false,
              shopColor: AppConfig.SHOP_COLOR,
            }
        },
        created () {
            const wrap = document.getElementById('shopsListWrap');
            if (wrap) {
                this.execute = true
            }
        },
      mounted() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (urlParams.has('cat_id')) {
          this.categoryIdFromUrl = true
          urlParams.getAll('cat_id').forEach(categoryID => {
            this.$store.dispatch('setCategory', Number(categoryID))
          })
        }
      },
      computed: {
        cssProps() {
          return {
            '--shop-color': this.shopColor,
          }
        }
      }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue